﻿const SearchBoxValidationCallback = (function() {
    const _listeners = [];

    const addListener = (searchType, listener) => {
        _listeners.push({
            searchType: searchType,
            listener: listener
        });
    }
    const invoke = (searchType) => {
        //cannot validate straight away as the pax popup prevents checking passengers until it is closed
        setTimeout(() => {
                _listeners
                    .filter(l => l.searchType == searchType)
                    .forEach(l => l.listener());
            },
            100);
    };

    return {
        addListener: addListener,
        invoke: invoke
    };
})();

const searchBoxes = (function () {
    const SearchBoxFactory = (function() {
        const bind = (target, type) => {
            switch (type) {
            case "Product":
                return new AttractionSearchBox(target);
            case "Crossing":
                return new CrossingSearchBox(target);
            case "Excursion":
                return new ExcursionsSearchBox(target);
            default:
                throw "Unknown search box";
            }
        };

        return {
            for: bind
        };
    })();

    const editSearch = (target, type) => {
        let search = SearchBoxFactory.for(target, type);
        let initiliseTask = search.Initialise();
        let rememberedSearchElm = document.querySelector("[name=searchCriteria]");

        if (rememberedSearchElm) {
            let rememberedSearch = JSON.parse(rememberedSearchElm.value);

            return initiliseTask.then(_ => {
                search.bind(rememberedSearch);
            });
        }

        return initiliseTask;
    };

    const defaultSearch = (target, type) => {
        let search = SearchBoxFactory.for(target, type);

        return search.Initialise();
    };

    return {
        defaultSearch: defaultSearch,
        editSearch: editSearch
    };
})();

searchBoxes.formWrappers = (function () {
    const syncWrappedSelectCaption = (selectField) => {
        let selectedOption = selectField.querySelector("option[selected]");
        let caption = selectedOption ? selectedOption.dataset["textvalue"] || selectedOption.innerText : "";

        selectField.closest(".large-select-list").querySelector("[data-select-type] .large-select__value").innerHTML = caption;
    };

    const setSelectedValue = (selectField, value) => {
        optionSelectSetValueAndSelected(selectField, value);
        syncWrappedSelectCaption(selectField);
    };

    const bindList = (selectField, keyValues, selectedKey) => {
        selectField.innerHTML = '';

        keyValues.forEach(kv => {
            let option = new Option(kv.value, kv.key, kv.key == selectedKey);
            option.dataset["textvalue"] = kv.value;
            selectField.appendChild(option);
        });

        selectField.value = selectedKey;
        syncWrappedSelectCaption(selectField);
    };

    return {
        bindList: bindList,
        setSelectedValue: setSelectedValue
    };
})();

searchBoxes.dateTimes = (function () {
    const setWrappedSelectText = (container, text) => {
        container.querySelector("[data-select-type] .large-select__value").innerHTML = text;
    };

    const buildUnixString = (date, hours, minutes) => `${date} ${hours}:${minutes}:00`;

    const getValues = (container) => {
        let rawDate = container.querySelector(".date-time-picker__date input[type=hidden]").value;
        let hours = container.querySelector("[data-select-hours]").value;
        let minutes = container.querySelector("[data-select-minutes]").value;

        return {
            date: rawDate,
            hours: hours,
            minutes: minutes,
            parsedDate: () => rawDate ? new moment(buildUnixString(rawDate, hours, minutes)) : undefined
        };
    };

    const setDate = (container, d) => {
        let momentDateTime = new moment(d);
        let dateContainer = container.classList.contains("date-time-picker__date")
            ? container
            : container.querySelector(".date-time-picker__date");

        dateContainer.closest(".date-time-picker").querySelector(".time-popup__selected-date").innerHTML = momentDateTime.format("DD MMMM, YYYY");
        dateContainer.querySelector("input[type=hidden]").value = momentDateTime.format('YYYY-MM-DD');
        setWrappedSelectText(dateContainer, momentDateTime.format("DD/MM/YYYY"));
    };

    const setTime = (container, d) => {
        let momentDateTime = new moment(d);
        let timeContainer = container.classList.contains("date-time-picker__time")
            ? container
            : container.querySelector(".date-time-picker__time");

        let hourElement = timeContainer.querySelector("[data-select-hours]");
        let minuteElement = timeContainer.querySelector("[data-select-minutes]");

        var hours = momentDateTime.format("HH");
        var minutes = momentDateTime.format("mm");

        optionSelectSetValueAndSelected(hourElement, hours);
        optionSelectSetValueAndSelected(minuteElement, minutes);

        hourElement.parentElement.querySelector("input").value = hours;
        minuteElement.parentElement.querySelector("input").value = minutes;

        setWrappedSelectText(timeContainer, `${hours} : ${minutes}`);
    };

    const setDateTime = (container, d) => {
        setDate(container, d);
        setTime(container, d);
    };

    return {
        getValues: getValues,
        setDateTime: setDateTime,
        setDate: setDate,
        setTime: setTime,
        buildUnixString: buildUnixString
    };
})();


searchBoxes.passengers = (function () {
    const buildSelectionCaption = (formElm) => {
        return Array.from(formElm.querySelectorAll("[data-passengertype]"))
            .filter(x => x.value !== "0")
            .map(typeElement => {
                return typeElement.value === "1"
                    ? `${typeElement.value} ${typeElement.dataset.name}`
                    : `${typeElement.value} ${typeElement.dataset.pluralizedname}`;
            })
            .join(', ');
    };

    const setSelectedPax = (formElm, passengers) => {
        Array.from(formElm.querySelectorAll("[name=passengerType]")).forEach(passengerTypeElm => {
            let matches = passengers.filter(x => x.id == passengerTypeElm.dataset.id);

            optionSelectSetValueAndSelected(passengerTypeElm, matches.length == 1 ? matches[0].value : 0);
        });

        formElm.querySelector('[data-select-type=pax] .large-select__value').innerHTML = buildSelectionCaption(formElm);
    };
    
    const getSelectedForTypeId = (formElm, passengerId) => {
        return formElm.querySelector(`select[data-id='${passengerId}']`);
    };
    
    const getSelectedForTypeArrayId = (formElm, passengerIds) => {
        return Array.from(formElm.querySelectorAll(`select[data-id]`))
            .filter(type => passengerIds.includes(type.dataset.id));
    };

    return {
        setSelected: setSelectedPax,
        buildSelectionCaption: buildSelectionCaption,
        getSelectedForTypeId: getSelectedForTypeId,
        getSelectedForTypeArrayId: getSelectedForTypeArrayId
    };
})();

const setDefaultRoute = () => {
    const id = getAffiliateId()
    if (id !== "") {
        return window.fetch(`/api/data/SearchBox?name=${id}`)
            .then(response => response.json())
            .then(response=> {
                const dataSearch = document.querySelector("[data-search='herosearch']")
                if (dataSearch && response.DefaultRoute !== "" && response.DefaultRoute != null) {
                    dataSearch.dataset["defaultRoute"] = response.DefaultRoute
                }
            })
    }else{
        return Promise.resolve()
    }
}

const getAffiliateId = () => {
    const affiliateId = document.querySelector("[data-affiliate-id]");
    if(affiliateId){
     return affiliateId.value;   
    }
    return "";
}

const setAffiliateName = () => {
    const affiliate = getAffiliateId()
    if(affiliate !== ""){
        window.fetch(`/api/data/GetAffiliateName/${affiliate}`)
            .then(response => response.json())
            .then(response=> {
                document.querySelectorAll("#Affiliate").forEach(x=>x.value = response);
            });
    }
    
    
}

const SearchBoxTabs = (function () {
    
    const initSearchBox = (searchBoxContainer, type) => {
        if (typeof searchBoxContainer.dataset.loaded === 'undefined') {
            searchBoxContainer.dataset.loaded = true;
           
            searchBoxes.defaultSearch(searchBoxContainer, type);

        }
    };

    
    const setupTab = (tabNum, searchBoxContainerSelector, type) => {
        let searchBoxTab = document.querySelector(`[data-tabs="herosearch"] [data-target="${tabNum}"]`);
        let searchBoxContainer = document.querySelector(`.hero-search ${searchBoxContainerSelector}`);

        if (!searchBoxTab || !searchBoxContainer) {
            return;
        }

       
        if (searchBoxTab.classList.contains("active")) {
            initSearchBox(searchBoxContainer, type);
        } else {
            searchBoxTab.addEventListener('click',
                () => {
                    initSearchBox(searchBoxContainer, type);
                   
                });
        }
    };

    const init = () => {
        setDefaultRoute()
            .then(_ =>{
                setupTab(0, "[data-crossingSearchBox]", "Crossing");
                setupTab(1, "[data-attractionSearchBox]", "Product");
                setupTab(2, "[data-excursionsSearchBox]", "Excursion");
        })
       
    };

    return {
        init: init
    };
})();

document.addEventListener("DOMContentLoaded",
    () => SearchBoxTabs.init());